export const TEAK_ENTITY_STATUS = {
	available: 'available',
	booked: 'booked',
};
